import "./propTypes";
import { Modal, Spin } from "antd";
import { cloneElement, useState } from "react";
import { useSelector } from "react-redux";
import "./RedWarningModal.scss";
import { Delete, AlertIcon, ModalXIcon } from "../../../assets/icons";
import MondayButton from "../MondayButton/MondayButton";
import { CheckOutlined } from "@ant-design/icons";

/**
 *
 * @param {RedWarningModalTypes} props - The props for MyComponent.
 * @returns {JSX.Element} - The rendered component.
 */

/**
 *
 * Simple usage:
 * <RedWarningModal
 *      visible={true}
 *      onCancel={() => {
 *         setVisible(false)
 *          console.log("cancelled");
 *          }}
 *      setVisible={setVisible}
 *      children={<div>Are you sure...</div>}
 *      footerProps={{
 *        onConfirm: () => {
 *          console.log("confirmed");
 *        },
 *      }}
 *    />
 *
 */

function RedWarningModal({
  visible,
  onCancel = () => {},
  setVisible = () => {},
  children,
  TitleIcon = AlertIcon,
  titleText = "Warning",
  footer,
  modalClassName = "",
  footerProps = {},
  confirmModal = false, //grey header -> default header color is red
  deleteModal = false, //add trash icon
  modalProps = {},
  noHeaderIcons = false,
  transformIcon = {
    transform: "rotate(-22deg) scale(3.5)",
  },
  disableOnConfirm = true,
}) {
  const [disableSave, setDisableSave] = useState(false);
  const {
    onConfirm = () => {},
    saveText = "Confirm",
    saveDisabled = false,
    SaveIcon = CheckOutlined,
    CancelIcon = ModalXIcon,
    saveClassName = "mondayButtonGreen",
    cancelClassName = "mondayButtonRed",
    closeText = "Cancel",
  } = footerProps || {};

  function onSaveConfirm() {
    if (disableOnConfirm) {
      setDisableSave(true);
    }
    onConfirm();
  }

  const initialFooter = footer
    ? footer
    : [
        {
          text: closeText,
          onClick: onCancel,
          disabled: false,
          Icon: CancelIcon,
          className: cancelClassName,
        },
        {
          text: saveText,
          onClick: onSaveConfirm,
          disabled: saveDisabled || disableSave,
          Icon: SaveIcon,
          className: saveClassName,
        },
      ];
  const { isDarkMode } = useSelector((state) => state.usersList);

  //region RETURN
  return (
    <Modal
      {...{
        open: visible,
        onCancel: () => {
          setVisible(false);
        },
        "data-testid": "red-warning-modal",
        title: (
          <div className="warningModalTitleContainer">
            <span className="warningModalTitle">
              {noHeaderIcons ? null : deleteModal ? <Delete /> : <TitleIcon />}
              {titleText}
            </span>
            {noHeaderIcons ? null : deleteModal ? (
              <Delete
                fill="#ffffff80"
                style={{
                  transform:
                    "rotate(-32deg) scale(3.5) translateX(2px) translateY(4px) ",
                }}
              />
            ) : (
              <TitleIcon
                fill="#ffffff80"
                style={{
                  ...transformIcon,
                }}
              />
            )}
          </div>
        ),
        footer:
          footer === null
            ? null
            : (initialFooter || []).map(
                (
                  {
                    text = "",
                    onClick = () => {},
                    disabled = false,
                    Icon = null,
                    className = "",
                    ...restProps
                  },
                  i
                ) => (
                  <MondayButton
                    key={i}
                    onClick={onClick}
                    Icon={!Icon ? null : <Icon />}
                    disabled={disabled}
                    className={className}
                    data-testid={"warning-modal-button" + text}
                    hasIcon={!!Icon}
                    {...restProps}
                  >
                    {text}
                  </MondayButton>
                )
              ),
        centered: true,
        closeIcon: false,
        className: `redWarningsModal ${isDarkMode && "redWarningsModalDark"} 
       ${modalClassName} ${confirmModal && !deleteModal && "confirmModal"}`,
        ...modalProps,
      }}
    >
      {children}
    </Modal>
  );
}

export default RedWarningModal;
